import React, { useEffect, useRef } from 'react';
import { ExcelColumn, ExcelFile, ExcelSheet } from 'react-xlsx-wrapper';

/*
 * builds the XLSX in the browser from the full /reports/data JSON (master), with the
 * hidden-ExcelFile pattern of reports/nutrition_program_payments.
 */
const XlsxExport = ({ sheet, on_done }) => {
  const ref = useRef(null);

  useEffect(() => {
    try {
      const btn = ref.current && ref.current.querySelector('button');
      if (!btn) throw new Error('the XLSX builder did not render');
      btn.click();
      on_done(null);
    } catch (e) {
      on_done(e);
    }
    // One click per mount; the parent remounts for the next export.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <span ref={ref} style={{ display: 'none' }} aria-hidden="true">
      <ExcelFile element={<button type="button">Build XLSX</button>} filename={sheet.file_name}>
        <ExcelSheet data={sheet.rows} name={sheet.sheet_name}>
          {sheet.columns.map((c) => (
            <ExcelColumn key={c.value} label={c.label} value={c.value} />
          ))}
        </ExcelSheet>
      </ExcelFile>
    </span>
  );
};

export default XlsxExport;
